export default "/images/book.svg?1eb461c1714bea41b70d160ad25dc9dc";